import {errorToString} from "@cdx/common";

/**
 * What a mutation rejects with when the server refused it or it never reached the server. `cause`
 * holds the server's error code or field-error map; `shown` is set when a toast already said why.
 */
export class MutationRefusal extends Error {
  readonly shown: boolean;

  constructor(reason: unknown, {shown = false}: {shown?: boolean} = {}) {
    super(errorToString(reason), {cause: reason});
    this.name = "MutationRefusal";
    this.shown = shown;
  }
}

/** The server's error code for a refused mutation, or the value itself for any other rejection. */
export const refusalReason = (e: unknown) => (e instanceof MutationRefusal ? e.cause : e);
